import { NxIconModule, NxStatusIconSize, NxStatusIconType } from '@allianz/ng-aquila/icon';
import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';

@Component({
  standalone: true,
  selector: 'allianz-status-icon',
  template: `
    <nx-icon
      [size]="size()"
      [name]="name()"
    ></nx-icon>
  `,
  styleUrls: ['./status-icon.component.scss'],
  host: {
    '[class]': 'classAttribute()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NxIconModule],
})
export class StatusIconComponent {
  size = input<NxStatusIconSize>('auto');
  type = input.required<NxStatusIconType>();

  readonly name = computed<string>(() => this.mapStatusToIconName(this.type()));
  readonly classAttribute: Signal<string> = computed(() => {
    return `icon-size--${this.size()} icon-type--${this.type()}`;
  });

  private mapStatusToIconName(type: NxStatusIconType): string {
    switch (type) {
      case 'success':
        return 'check-circle';
      case 'info':
        return 'info-circle';
      case 'error':
        return 'exclamation-triangle';
      case 'warning':
        return 'exclamation-circle-warning';
    }
  }
}
